import React from 'react';
import { 
  Hidden,
  Drawer,
  List,
} from '@material-ui/core';

import ShowPicker from './ShowPicker';
import NavLinks from './NavLinks';
import useStyles from '../styles/Drawer';
import ShowDrawer from './ShowDrawer';

const SideNav: React.SFC = () => {
  const classes = useStyles();
  const [isShowDrawerOpen, setShowDrawerOpen] = React.useState(false);
  
  const handleDrawerClose = () => {
    setShowDrawerOpen(false);
  }
  const handlePickerClick = () => {
    setShowDrawerOpen(true);
  }

  return (
    <>
      <nav className={classes.drawer}>
        <Hidden xsDown>
          <Drawer 
            variant="permanent"
            anchor="left"
            classes={{
              paper: classes.drawerPaper,
            }}
            open
          >
            <ShowPicker isClickable onClick={handlePickerClick} />
            <List className={classes.drawerContent}>
              <NavLinks />
            </List>
          </Drawer>
        </Hidden>
      </nav>
      <ShowDrawer isOpen={isShowDrawerOpen} onClose={handleDrawerClose} />
    </>
  );
}

export default SideNav;
